/**
 * Array transformation utilities
 * Pure functions for common array operations
 */

/**
 * Sort array by priority order of IDs
 * Returns items in the same order as the priority array
 * @param items - Array of items with id property
 * @param priorityIds - Array of IDs defining the desired order
 * @returns Sorted array (does not mutate original)
 */
export function sortByPriorityOrder<T extends { id: number }>(
  items: T[],
  priorityIds: number[]
): T[] {
  const itemsMap = new Map(items.map((item) => [item.id, item]));
  
  return priorityIds
    .map((id) => itemsMap.get(id))
    .filter((item): item is T => item !== undefined);
}

/**
 * Remove duplicates from array based on ID
 * @param items - Array of items with id property
 * @returns Deduplicated array (does not mutate original)
 */
export function deduplicateById<T extends { id: number }>(items: T[]): T[] {
  const seen = new Set<number>();
  return items.filter((item) => {
    if (seen.has(item.id)) {
      return false;
    }
    seen.add(item.id);
    return true;
  });
}

